<div class="tooltip-arrow"></div>
<div [innerHTML]="value"></div>
